export const AppSettingKey = {
  ORDER_MINIMUM_AMOUNT: 'ORDER_MINIMUM_AMOUNT',
}
